import React from "react";
import { useTrack } from "@/Logigate/hooks/useTrack";
import { SeletorDoGrupo } from "./SeletorDoGrupo";

interface Hotel {
    id: number;
    nome: string;
    slug: string;
}

interface HotelSeletorProps {
    hoteis: Hotel[];
    hotelSelecionadoId: number;
    onHotelChange?: (hotel: Hotel, menu: any[]) => void;
}

/** O hotel do grupo «Gestão Hoteleira» (a escolha fica guardada neste aparelho). */
export default function HotelSeletor({ hoteis, hotelSelecionadoId, onHotelChange }: HotelSeletorProps) {
    const { track } = useTrack("hotelaria");

    return (
        <SeletorDoGrupo
            itens={hoteis}
            selecionadoId={hotelSelecionadoId}
            chaveGuardada="hotel_selecionado_id"
            caminhoMenu={(id) => `/hotelaria/menu/${id}`}
            icone="mdi:hotel"
            rotulo="Hotel"
            placeholder="Escolher o hotel"
            nadaEncontrado="Nenhum hotel encontrado"
            textoErro="Não foi possível carregar o menu do hotel. Tenta de novo."
            aoEscolher={(hotel) => track("clicou", "hotelaria_selecionar_hotel", { md: { hotel_id: hotel.id, hotel_nome: hotel.nome } })}
            onTrocar={onHotelChange}
        />
    );
}
